// biome-ignore lint/style/useFilenamingConvention: TanStack Router uses $param convention for dynamic routes
import { createRoute } from '@tanstack/react-router';
import { ProductionDeclarationMaterialPage } from '@/pages/production-declaration/production-declaration-material-page';
import { Route as ProductionDeclarationRoute } from './production-declarations.$id';

export const Route = createRoute({
  getParentRoute: () => ProductionDeclarationRoute,
  path: 'materials/$materialId',
  component: () => <ProductionDeclarationMaterialPage />,
  staticData: {
    stepKey: 'statement',
  },
});
